import { PropsWithChildren } from 'react'

import styles from './CheckoutChip.module.scss'

/** Pill for short order facts, e.g. the order format or who it's for */
export default function CheckoutChip({ children }: PropsWithChildren) {
  return <span className={styles.chip}>{children}</span>
}
